import { useMemo, useContext, useEffect, useRef, useState } from "react";
import Head from "next/head";
import Page from "../layouts/main";
import Context from "../components/context/context";
import CTA from "../components/CTA/cta.module";
import Footer from "../components/Footer/footer.module";
import Picture from "../components/picture/picture.module";
import Memberships from "../components/memberships/memberships.module";
import GiftCertificates from "../components/gift-certificates/gift-certificates.module";
import styles from "../styles/modules/pricing.module.scss";
import settings from "../util/settings";
import { DEFAULT_LOCATION } from "../util/locations";
import trackBookingEvent from "../util/conversion-events/booking-event";

const Pricing = (props) => {
  const { location } = useContext(Context);
  const locationToUse = useMemo(
    () => (location ? location : DEFAULT_LOCATION),
    [location]
  );

  const pageRef = useRef();
  const [analytics, setAnalytics] = useState();

  useEffect(() => {
    if (pageRef.current) {
      setAnalytics(pageRef.current.analytics);
    }
  }, []);

  return (
    <Page id={styles["page-pricing"]} ref={pageRef}>
      <Head>
        <title>Pricing - Kudos Golf</title>
      </Head>

      <section
        className={`section-content row ${styles["section-offers-intro"]}`}
      >
        <div className="col-lg-7">
          <h2 className={styles.header}>
            Our competitive rates and Memberships allow you to improve your
            game, for less.
          </h2>
          <div className={styles["offers-intro-copy"]}>
            <p className="text-body-large">
              <span className={styles["highlighted-text"]}>${locationToUse.price.openBay}/hour</span> rate
              for regular sessions booked in our Open Bays, with a minimum
              booking time of 30 minutes.
            </p>
            {locationToUse.price.privateBay && 
              <p className="text-body-large">
                Private Bays are available for a premium rate of ${locationToUse.price.privateBay}/hour.
              </p>
            }
          </div>

          <CTA
            href={locationToUse.endpoints.SCHEDULER}
            className="button mt-4 mb-5"
            onClick={trackBookingEvent}
            text="Book now"
            analytics={analytics}
            src="/pricing"
            dest="booking-system"
          />
        </div>

        <div className={`offset-lg-1 col-lg-4`}>
          <Picture
            src={
              settings.ASSET_PATH +
              "images/pricing/golfer-shooting-golf-ball.jpg?webp"
            }
            alt={"Golfer shooting golf ball"}
            title={"Golfer shooting golf ball"}
            className={styles["offers-intro-image"]}
          />
        </div>

        <hr />
      </section>

      <section className={`section-content ${styles["section-memberships"]}`}>
        <h3 className={styles["section-memberships-heading"]}>
          Get more value when you buy sessions in advance.
        </h3>
        <div className={styles["section-memberships-copy"]}>
          <p className="text-body-medium">
            For our frequent golfers, we offer a variety of Prepaid Memberships
            so you can save on future sessions. All Prepaid Memberships can be
            used on your choice of bay for any duration, subject to availability
            at the time of booking each session.
          </p>
        </div>

        <Memberships analytics={analytics} />

        <p className="text-body-small" style={{ maxWidth: 720 }}>
          *Memberships cannot be combined with other coupons and promotions.
          Membership price and value subject to change. No expiry on pre-paid
          Membership values.
        </p>
      </section>

      {/* <section className={`section-content ${styles['section-gift-certificates']}`}>
        <Picture src={`${ASSET_PATH}gift-cards-section-bg.jpg`} alt='Hand picking up golf ball' title='Hand picking up golf ball' className={styles['section-gift-certificates-background']} />

        <h3 className={styles['section-gift-certificates-heading']}>Why not give the gift of golf?</h3>
        <div className={styles['section-gift-certificates-copy']}>
          <p className='text-body-medium'>We offer digital gift certificates in a variety of denominations.<br/>Vouchers can be used to book any bay for any duration of time, until funds are diminished. Gift certificates never expire.</p>
        </div>

        <CTA href={locationToUse.endpoints.GIFT_CERTIFICATES} className='button mt-4 mb-5' text='Buy a gift certificate' analytics={analytics} src='/pricing' dest={locationToUse.endpoints.GIFT_CERTIFICATES} />

      </section> */}

      <GiftCertificates analytics={analytics} />

      {/* <CTA
          className={'text-link'}
          href='https://portal.e6golf.com/login'
          text='E6 portal'
          target='_blank'
          analytics={analytics}
          src='ABOUT-US' dest='https://portal.e6golf.com/login' /> */}

      <Footer />
    </Page>
  );
};

export default Pricing;
